module.exports = __webpack_public_path__ + "img/avatar6.5ec21e89.png";